/** @file An IK solver's constraint, asserted to have the solver's chain length (IK_INVALID otherwise). */
import { coreFail } from '../_internal/coreFail';
import type { IkData, SkeletonData } from '../skeletonData';

/**
 * data.ik[ik] when its chain has exactly `count` bones (1 for solveOneBone, 2 for solveTwoBone); otherwise throws
 * IK_INVALID through coreFail at `ik[i].bones` (`ik[i]` for an index the skeleton lacks). The loader and the
 * compiler already refuse such rigs, so this guards hand-built SkeletonData; the success path allocates nothing.
 */
export function solverChain(data: SkeletonData, ik: number, count: 1 | 2): IkData {
  const c = data.ik[ik];
  if (c !== undefined && c.bones.length === count) return c;
  const name = c?.name ?? String(ik);
  const solver = count === 1 ? 'the one-bone solver needs 1 bone' : 'the two-bone solver needs 2 bones';
  const reason = c === undefined ? 'no such constraint' : `${solver}, got ${String(c.bones.length)}`;
  return coreFail('IK_INVALID', `IK constraint "${name}" is invalid: ${reason}`, {
    params: { ik: name, reason },
    path: c === undefined ? `ik[${String(ik)}]` : `ik[${String(ik)}].bones`,
  });
}
